export class EditprojectCycleConstants {
    static COMPONENT_NAME = "Edit project cycle";
}
